import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        document.addEventListener("direct-upload:initialize", this.initializeUpload)
        document.addEventListener("direct-upload:progress", this.progress)
        document.addEventListener("direct-upload:end", this.end)
    }

    disconnect() {
        document.removeEventListener("direct-upload:initialize", this.initializeUpload)
        document.removeEventListener("direct-upload:progress", this.progress)
        document.removeEventListener("direct-upload:end", this.end)
    }

    initializeUpload(event) {
        const { target, detail } = event
        const { id, file } = detail
        const progressBar = document.createElement("progress")
        progressBar.id = `direct-upload-${id}`
        progressBar.value = 0
        progressBar.max = 100
        target.insertAdjacentElement("afterend", progressBar)
    }

    progress(event) {
        const { id, progress } = event.detail
        const progressBar = document.getElementById(`direct-upload-${id}`)
        if (progressBar) progressBar.value = progress
    }

    end(event) {
        const { id } = event.detail
        const progressBar = document.getElementById(`direct-upload-${id}`)
        if (progressBar) progressBar.remove()
    }

    reset(event) {
        // Active Storage leaves file inputs disabled after uploading. Turbo keeps
        // this form on the page while column matching opens in a dialog.
        this.element.querySelectorAll('input[type="file"][data-direct-upload-url]:disabled').forEach(input => {
            this.element.querySelectorAll('input[type="hidden"]').forEach(field => {
                if (field.name === input.name) field.remove()
            })
            if (event.detail.success) input.value = ""
            input.disabled = false
        })
    }
}
